export enum ReportTemplateFieldCategory {
  Unknown,
  Settings,
  Logo,
  HeaderData,
  TypeData,
  MeasurementData,
  Graphics,
  Miscellaneous,
}
